import { useRecoilValue } from 'recoil'

import CardWithBorder from '../../../components/CardWithBorder'
import Heatmap from '../../../components/Heatmap'
import useLocationDateTimeForm from '../../../hooks/useLocationDateTimeForm'
import { ServiceAtom } from '../../../recoil/atoms'
import useGetStoreVisitCountHourDayOfWeekHourDayOfWeek from '../hooks/useGetStoreVisitCountHourDayOfWeek'

function UserWeeklyTrafficPatterns({ className }: { className?: string }) {
  const { form } = useLocationDateTimeForm()
  const service = useRecoilValue(ServiceAtom)

  const { storeVisitCountHourDayOfWeek, storeVisitCountHourDayOfWeekLoading } =
    useGetStoreVisitCountHourDayOfWeekHourDayOfWeek({
      serviceId: service.value,
      siteId: form.siteId,
      floorId: form.floorId,
      siteGroupId: form.siteGroupId,
      fromDate: form.fromDate,
      toDate: form.toDate,
    })

  const series =
    storeVisitCountHourDayOfWeek?.storeVisitCountHourDayOfWeekDatas?.map((data) => {
      // for change from (sun -> sat) to (mon -> sun)
      const array = data.series.map((d) => ({
        x: d.dayOfWeek,
        y: d.numOfPeople,
      }))
      const rearrange = [...array.slice(1), array[0]]
      return {
        name: data.hour,
        data: rearrange,
      }
    // 23:00スタート問題を解決させるため、seriesを逆転させる処理を追加。
    }).toReversed() ?? []

  return (
    <CardWithBorder className={className} title='曜日時間帯別来訪者分析' visible={storeVisitCountHourDayOfWeekLoading}>
      <Heatmap series={series} max={storeVisitCountHourDayOfWeek?.maxValue ?? 0} height='min-h-[76vh]' />
    </CardWithBorder>
  )
}

UserWeeklyTrafficPatterns.defaultProps = {
  className: '',
}

export default UserWeeklyTrafficPatterns
